__turbopack_context__.v({
  "absolute": "modal-module-sass-module__gpulFq__absolute",
  "alignMiddle": "modal-module-sass-module__gpulFq__alignMiddle",
  "backdrop": "modal-module-sass-module__gpulFq__backdrop",
  "background": "modal-module-sass-module__gpulFq__background",
  "base": "modal-module-sass-module__gpulFq__base",
  "body": "modal-module-sass-module__gpulFq__body",
  "borderradius": "modal-module-sass-module__gpulFq__borderradius",
  "bottom": "modal-module-sass-module__gpulFq__bottom",
  "boxshadow": "modal-module-sass-module__gpulFq__boxshadow",
  "casino": "modal-module-sass-module__gpulFq__casino",
  "column": "modal-module-sass-module__gpulFq__column",
  "container": "modal-module-sass-module__gpulFq__container",
  "content": "modal-module-sass-module__gpulFq__content",
  "custom": "modal-module-sass-module__gpulFq__custom",
  "default": "modal-module-sass-module__gpulFq__default",
  "direction": "modal-module-sass-module__gpulFq__direction",
  "dropdown": "modal-module-sass-module__gpulFq__dropdown",
  "fixed": "modal-module-sass-module__gpulFq__fixed",
  "height": "modal-module-sass-module__gpulFq__height",
  "hidden": "modal-module-sass-module__gpulFq__hidden",
  "large": "modal-module-sass-module__gpulFq__large",
  "left": "modal-module-sass-module__gpulFq__left",
  "login": "modal-module-sass-module__gpulFq__login",
  "modal": "modal-module-sass-module__gpulFq__modal",
  "modalBaseAnimate": "modal-module-sass-module__gpulFq__modalBaseAnimate",
  "none": "modal-module-sass-module__gpulFq__none",
  "not-visible": "modal-module-sass-module__gpulFq__not-visible",
  "onlyTop": "modal-module-sass-module__gpulFq__onlyTop",
  "opacity": "modal-module-sass-module__gpulFq__opacity",
  "overflow": "modal-module-sass-module__gpulFq__overflow",
  "page": "modal-module-sass-module__gpulFq__page",
  "position": "modal-module-sass-module__gpulFq__position",
  "preload": "modal-module-sass-module__gpulFq__preload",
  "right": "modal-module-sass-module__gpulFq__right",
  "rightFullPage": "modal-module-sass-module__gpulFq__rightFullPage",
  "visible": "modal-module-sass-module__gpulFq__visible",
  "wallet": "modal-module-sass-module__gpulFq__wallet",
  "walletVerify": "modal-module-sass-module__gpulFq__walletVerify",
  "width": "modal-module-sass-module__gpulFq__width",
});
